module.exports = __webpack_public_path__ + "assets/9ccb37bf0512c6f9b24b597c9239b3f2.png";